export default __webpack_public_path__ + "static/autism_resources-84bd5c11c08b6121cb5d20f680f4dfb3.jpeg";